module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-Bold.a6c7047d.ttf";